// --- custom-pdp-scripts.js ---
(function() {

    // --- CONFIGURATION ---
    // !!! VERIFY THIS URL IS CORRECT FOR THE CA SITE'S SVG ASSET !!!
    var NEW_GUARANTEE_BADGE_URL = '//us.lusome.com/cdn/shop/t/8/assets/30-day-guarantee.svg?v=79873753232508159771746211062'; // EXAMPLE - REPLACE
    var WISHLIST_SELECTOR = 'div.gw-wl-add-to-wishlist-placeholder';
    var ADD_TO_CART_CONTAINER_SELECTOR = 'div.product_qty_and_button';
    var SAFE_CHECKOUT_SELECTOR = 'div.safe_secure_checkout';

    // --- FUNCTION TO APPLY CHANGES ---
    function modifyProductPage() {
        // console.log('PDP MOD: Attempting modifications...'); // Keep console logs for initial testing

        try {
            var wishlistBlock = document.querySelector(WISHLIST_SELECTOR);
            var addToCartContainer = document.querySelector(ADD_TO_CART_CONTAINER_SELECTOR);
            var safeCheckoutContainer = document.querySelector(SAFE_CHECKOUT_SELECTOR);

            var elementsFound = true;

            if (!wishlistBlock) { /* console.log('PDP MOD: Wishlist block not found'); */ elementsFound = false; }
            if (!addToCartContainer) { /* console.log('PDP MOD: ATC container not found'); */ elementsFound = false; }
            if (!safeCheckoutContainer) { /* console.log('PDP MOD: Safe checkout container not found'); */ elementsFound = false; }

            if (!elementsFound) {
                // console.log('PDP MOD: Essential elements missing.');
                return false;
            }

            if (wishlistBlock.previousElementSibling !== addToCartContainer) {
                addToCartContainer.parentNode.insertBefore(wishlistBlock, addToCartContainer.nextSibling);
                // console.log('PDP MOD: Moved Wishlist block.');
            }

            if (safeCheckoutContainer && !safeCheckoutContainer.querySelector('img.convert-guarantee-badge')) {
                var guaranteeImg = document.createElement('img');
                guaranteeImg.src = NEW_GUARANTEE_BADGE_URL;
                guaranteeImg.alt = '30 Day Comfort Guarantee';
                guaranteeImg.classList.add('convert-guarantee-badge');
                safeCheckoutContainer.insertBefore(guaranteeImg, safeCheckoutContainer.firstChild);
                // console.log('PDP MOD: Added Guarantee Badge.');
            }

            // console.log('PDP MOD: Modifications applied/present.');
            return true;

        } catch (error) {
            console.error('PDP MOD ERROR:', error);
            return false;
        }
    }

    // --- WAIT FOR ELEMENTS AND RUN ---
    // Only run on product pages
    if (window.location.pathname.indexOf('/products/') === 0) {
        var intervalCount = 0;
        var maxIntervals = 50;
        var checkInterval = setInterval(function() {
            intervalCount++;
            var changesAppliedOrPresent = false;

            if (document.querySelector(ADD_TO_CART_CONTAINER_SELECTOR) && document.querySelector(SAFE_CHECKOUT_SELECTOR)) {
                try {
                    changesAppliedOrPresent = modifyProductPage();
                } catch (e) {
                    console.error("PDP MOD ERROR in call:", e);
                }
            }

            if (changesAppliedOrPresent || intervalCount >= maxIntervals) {
                // if (!changesAppliedOrPresent && intervalCount >= maxIntervals) { console.log('PDP MOD: Timeout.'); }
                // else if (changesAppliedOrPresent) { console.log('PDP MOD: Interval finished.'); }
                clearInterval(checkInterval);
            }
        }, 100);
    }
})();